
import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

interface EmptyStateProps {
  onAddQuestion: (e: React.MouseEvent) => void;
  type: 'categories' | 'category' | 'questions';
}

export function EmptyState({ onAddQuestion, type }: EmptyStateProps) {
  switch(type) {
    case 'categories':
      return (
        <div className="text-center p-6 border border-dashed rounded">
          <p className="text-muted-foreground">No categories have been created yet.</p>
        </div>
      );
      
    case 'category':
      return (
        <div className="text-center p-6 border border-dashed rounded">
          <p className="text-muted-foreground">No category selected.</p>
        </div>
      );
      
    case 'questions':
      return (
        <div className="text-center p-6 border border-dashed rounded">
          <p className="text-muted-foreground">No questions in this category yet.</p>
          <Button 
            type="button"
            onClick={onAddQuestion} 
            className="mt-4"
          >
            <Plus className="mr-2" />
            Add Question
          </Button>
        </div>
      );
      
    default:
      return null;
  }
}
